import { useEffect, useRef, useState } from 'react';
import PropTypes from 'prop-types';
import Text from '@hiredigital/ui/Text/Text';
import { Section, SectionContainer } from '@components/Section';
import { getPressList } from '@cms/pressList';
import { NextArrow, PrevArrow, Types } from '@components/Press/PressSlider/arrows';

import PressSlider from '@components/Press/PressSlider/PressSlider';

const PressSection = ({ title = 'In the Press', light = true }) => {
  const [pressData, setPressData] = useState();
  const sliderRef = useRef(null);

  useEffect(() => {
    const loadData = async () => {
      const { presses } = await getPressList();
      setPressData(presses);
      // console.log(presses);
    };
    loadData();
  }, []);

  const handleNext = () => {
    // console.log(sliderRef.current.scroll);
    sliderRef.current.scrollBy({ left: 350, behavior: 'smooth' });
    // sliderRef.current.scrollTo()
    // sliderRef.current?.manualScroll('next');
  };

  const handlePrev = () => {
    // console.log(sliderRef.current);
    sliderRef.current.scrollBy({ left: -350, behavior: 'smooth' });

    // sliderRef.current?.manualScroll('prev');
  };

  return pressData ? (
    <SectionContainer style={{ margin: 'auto' }}>
      <Section>
        <div style={{ display: 'flex' }}>
          <Text
            element='h2'
            size={Text.Size.SUBHEADLINE_LARGE}
            color={Section.Type.NORMAL}
            type={light ? Section.Color.BLACK : Section.Color.WHITE}>
            {title}
          </Text>
          <div style={{ display: 'flex', marginLeft: 'auto' }}>
            <PrevArrow onClick={handlePrev} type={light ? Types.LIGHT : Types.DARK} />
            <NextArrow onClick={handleNext} type={light ? Types.LIGHT : Types.DARK} />
          </div>
        </div>
        <PressSlider ref={sliderRef} light={light} pressData={pressData} />
      </Section>
    </SectionContainer>
  ) : null;
};
PressSection.propTypes = {
  title: PropTypes.string,
  light: PropTypes.bool,
};
export default PressSection;
